import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Plus, Send, CheckCircle, Download, Eye, FileText, Pencil, Trash2, MessageCircle, Copy } from 'lucide-react';
import { statusColors, statusLabels } from './constants';

export default function OrcamentosTab({ 
  orcamentos, 
  onNovoOrcamento, 
  onEnviar, 
  onAprovar, 
  onDownloadPDF, 
  onVerDetalhes,
  onEditar,
  onExcluir,
  onWhatsapp,
  onDuplicar
}) {
  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <Button onClick={onNovoOrcamento} data-testid="btn-novo-orcamento">
          <Plus className="w-4 h-4 mr-2" />
          Novo Orçamento
        </Button>
      </div>
      
      <div className="grid gap-4">
        {orcamentos.length === 0 ? (
          <Card>
            <CardContent className="py-8 text-center text-slate-500">
              <FileText className="w-12 h-12 mx-auto mb-3 text-slate-300" />
              <p>Nenhum orçamento encontrado</p>
              <p className="text-sm mt-1">Clique em "Novo Orçamento" para criar um</p>
            </CardContent>
          </Card>
        ) : (
          orcamentos.map(orc => (
            <Card key={orc.id} data-testid={`orcamento-${orc.id}`}>
              <CardHeader className="pb-2">
                <div className="flex items-center justify-between">
                  <div>
                    <CardTitle className="text-lg">{orc.numero_orcamento}</CardTitle>
                    <CardDescription>{orc.cliente_nome}</CardDescription>
                  </div>
                  <Badge className={statusColors[orc.status] || 'bg-gray-100'}>
                    {statusLabels[orc.status] || orc.status}
                  </Badge>
                </div>
              </CardHeader>
              <CardContent className="pb-2">
                <div className="grid grid-cols-3 gap-4 text-sm">
                  <div>
                    <span className="text-slate-500">Valor Total:</span>
                    <p className="font-semibold">R$ {orc.valor_total?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</p>
                  </div>
                  <div>
                    <span className="text-slate-500">Validade:</span>
                    <p>{orc.data_validade ? new Date(orc.data_validade).toLocaleDateString('pt-BR') : 'N/A'}</p>
                  </div>
                  <div>
                    <span className="text-slate-500">Itens:</span>
                    <p>{orc.itens?.length || 0} item(ns)</p>
                  </div>
                </div>
              </CardContent>
              <CardFooter className="flex flex-wrap gap-2 pt-2">
                {orc.status === 'rascunho' && (
                  <Button size="sm" onClick={() => onEnviar(orc.id)}>
                    <Send className="w-4 h-4 mr-1" />
                    Enviar
                  </Button>
                )}
                {orc.status === 'enviado' && (
                  <Button size="sm" variant="outline" className="text-green-600" onClick={() => onAprovar(orc.id)}>
                    <CheckCircle className="w-4 h-4 mr-1" />
                    Aprovar
                  </Button>
                )}
                <Button size="sm" variant="outline" onClick={() => onDownloadPDF(orc.id)}>
                  <Download className="w-4 h-4 mr-1" />
                  PDF
                </Button>
                <Button size="sm" variant="outline" className="text-emerald-700 border-emerald-300 hover:bg-emerald-50" onClick={() => onWhatsapp(orc)} data-testid={`btn-whatsapp-orcamento-${orc.id}`}>
                  <MessageCircle className="w-4 h-4 mr-1" />
                  WhatsApp
                </Button>
                <Button size="sm" variant="outline" onClick={() => onVerDetalhes(orc)}>
                  <Eye className="w-4 h-4 mr-1" />
                  Detalhes
                </Button>
                <Button size="sm" variant="outline" className="text-blue-600" onClick={() => onEditar(orc)} data-testid={`btn-editar-orcamento-${orc.id}`}>
                  <Pencil className="w-4 h-4 mr-1" />
                  Editar
                </Button>
                <Button size="sm" variant="outline" onClick={() => onDuplicar(orc)} data-testid={`btn-duplicar-orcamento-${orc.id}`}>
                  <Copy className="w-4 h-4 mr-1" />
                  Duplicar
                </Button>
                <Button size="sm" variant="outline" className="text-red-600 hover:bg-red-50" onClick={() => onExcluir(orc)} data-testid={`btn-excluir-orcamento-${orc.id}`}>
                  <Trash2 className="w-4 h-4 mr-1" />
                  Excluir
                </Button>
              </CardFooter>
            </Card>
          ))
        )}
      </div>
    </div>
  );
}
